module.exports = __webpack_public_path__ + "img/travelling-thali-brand_application-mobile_views.d4e828ad.jpg";